import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { getImgeUrl } from 'src/environments/environment';

@Component({
  selector: 'app-menuscript-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menuscript-details.component.html',
  styleUrl: './menuscript-details.component.scss'
})
export class MenuscriptDetailsComponent {
  isToggled = false;
  id
  menuscript
  imageURL = getImgeUrl()
  constructor(
    public themeService: ThemeCustomizerService, 
    private activeRouter: ActivatedRoute, 
    private publicService: PublicServiceService, 
  ) {
      this.themeService.isToggled$.subscribe(isToggled => {
          this.isToggled = isToggled;
      });
  }

  toggleTheme() {
      this.themeService.toggleTheme();
  }

  ngOnInit(): void {
    this.id = this.activeRouter.snapshot.params["id"]
    this.getDat()
  }

  getDat() {
    this.publicService.getRecordById(this.publicService.MENUSCRIPT_URL, this.id).subscribe({
      next: (res) => {
        this.menuscript = res
      },
      error: (err) => {
        console.log(err)
      }
    })
  }
}
